import { render } from "./BookingTrainer.vue?vue&type=template&id=28a7d4af"
import script from "./BookingTrainer.vue?vue&type=script&lang=js"
export * from "./BookingTrainer.vue?vue&type=script&lang=js"

import "./BookingTrainer.vue?vue&type=style&index=0&id=28a7d4af&lang=css"

import exportComponent from "/Users/teguhsangra/Web/GSD/xsport/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__